import React, { ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';
import logo from 'assets/icons/global/logo-20-lat.svg';
import Image from 'atomic/image';
import { PageProps } from 'interfaces/page-props';
import { getLogoAlt, getLogoTitle } from 'layouts/header/helpers/get-properties-title';

import './navigation.scss';

interface NavigationProsp {
    onToggle: () => void;
    isOpen: boolean;
}

const Navigation: React.FC<NavigationProsp> = () => {
    const pageUrl = useSelector((state: PageProps) => state.pageUrl);

    const Logo = (): ReactElement => (
        <Image src={logo} alt={getLogoAlt(pageUrl)} width={132}
            height={28} show={true} loading={'eager'}
        />
    );

    return (
        <nav className="navi">
            <a href="/" className="navi__logo" rel="start"
                aria-label="logo" title={getLogoTitle(pageUrl)}
            >
                {pageUrl === '/'
                    ? (
                        <h1>
                            <Logo />
                        </h1>
                    )
                    : (
                        <Logo />
                    )
                }
            </a>
        </nav>
    );
};

export default Navigation;
